// Shared product and cart controls. Generated from ms-product-extras.liquid.

if (!customElements.get('ms-product-extras')) {
  customElements.define('ms-product-extras', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.hasAttribute('data-separate-addons')) { this.connectStandalone(signal); return; }
      this.cards = [...this.querySelectorAll('[data-extra-card]')];
      this.cards.forEach(card => { card.variants = JSON.parse(card.querySelector('[data-extra-variants]').textContent); });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-extra-choice]');
        if (button && !button.disabled) {
          const selected = button.getAttribute('aria-pressed') === 'true';
          if (button.closest('[data-frame-match]')) this.cards.filter(card => card.hasAttribute('data-frame-match')).forEach(card => this.select(card, false));
          this.select(button.closest('[data-extra-card]'), !selected);
        }
        if (event.target.closest('[data-no-frame]')) this.cards.filter(card => card.hasAttribute('data-frame-match')).forEach(card => this.select(card, false));
        this.notify();
      }, {signal});
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-extra-select]')) return;
        const card = event.target.closest('[data-extra-card]');
        this.setVariant(card, card.variants.find(variant => String(variant.id) === event.target.value));
        this.notify();
      }, {signal});
      document.addEventListener('change', event => {
        if (!event.target.matches('input[data-option-position]') || event.target.form !== document.getElementById(this.dataset.mainForm)) return;
        this.variantPending = true;
        this.cards.filter(card => card.hasAttribute('data-frame-match') || card.hasAttribute('data-shoe-fit')).forEach(card => {
          this.select(card, false);
          card.querySelector('[data-extra-choice]').disabled = true;
        });
        this.notify();
      }, {capture:true, signal});
      document.addEventListener('variant:change', event => {
        if (event.target !== document.getElementById(this.dataset.mainForm)) return;
        this.variantPending = false;
        this.matchFrames(event.detail.variant);
        this.matchShoes(event.detail.variant?.options?.[Number(this.dataset.shoeSizePosition)]);
        this.notify();
      }, {signal});
      this.matchShoes(this.dataset.selectedShoeSize);
      this.notify();
    }
    connectStandalone(signal) {
      document.addEventListener('change', event => {
        if (!event.target.matches('input[data-option-position]') || event.target.form !== document.getElementById(this.dataset.mainForm)) return;
        this.standaloneVariantPending = true;
        this.matchStandaloneShoes(null);
      }, {capture:true, signal});
      document.addEventListener('variant:change', event => {
        if (event.target !== document.getElementById(this.dataset.mainForm)) return;
        this.standaloneVariantPending = false;
        this.matchStandaloneShoes(event.detail.variant?.options?.[Number(this.dataset.shoeSizePosition)]);
        this.querySelector('[data-extra-status]').textContent = '';
      }, {signal});
      this.addEventListener('change', event => {
        if (!event.target.matches('select[name="id"]')) return;
        const card = event.target.closest('[data-extra-card]');
        card.querySelector('[data-extra-price]').textContent = event.target.selectedOptions[0].dataset.price;
        this.querySelector('[data-extra-status]').textContent = '';
      }, {signal});
      this.addEventListener('submit', event => {
        const card = event.target.closest('[data-shoe-fit]');
        if (card && (card.hidden || this.standaloneVariantPending || event.target.elements.id?.value !== card.dataset.matchedVariant)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, {capture:true, signal});
      this.addEventListener('variant:add', () => {
        this.querySelector('[data-extra-status]').textContent = this.dataset.addedMessage;
      }, {signal});
      this.addEventListener('cart:error', event => {
        this.querySelector('[data-extra-status]').textContent = event.detail?.error || this.dataset.errorMessage;
      }, {signal});
      this.matchStandaloneShoes(this.dataset.selectedShoeSize);
    }
    matchStandaloneShoes(value) {
      const numeric = String(value || '').trim().match(/^(?:EU\s*)?(\d+(?:[.,]\d+)?)\s*(?:EU)?$/i);
      const size = this.dataset.shoeSizePosition !== '' && numeric ? Number(numeric[1].replace(',', '.')) : null;
      this.querySelectorAll('[data-shoe-fit]').forEach(card => {
        const variants = JSON.parse(card.querySelector('[data-extra-variants]').textContent);
        const selected = size !== null && variants.find(variant => {
          const range = variant.title.match(/\((\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)\)/);
          return range && size >= Number(range[1].replace(',', '.')) && size <= Number(range[2].replace(',', '.'));
        });
        card.hidden = !selected;
        card.dataset.matchedVariant = selected ? String(selected.id) : '';
        const input = card.querySelector('[name="id"]');
        if (input.tagName === 'SELECT') {
          [...input.options].forEach(option => {
            if (!option.value) return;
            option.disabled = option.value !== card.dataset.matchedVariant;
            option.hidden = option.disabled;
          });
        }
        input.value = card.dataset.matchedVariant;
        input.disabled = !selected;
        card.querySelector('[type="submit"]').disabled = !selected;
        if (selected) card.querySelector('[data-extra-price]').textContent = selected.price;
      });
    }
    select(card, selected) {
      const button = card.querySelector('[data-extra-choice]');
      button.setAttribute('aria-pressed', String(selected));
      if (!button.classList.contains('ms-extras__frame-card')) button.textContent = selected ? this.dataset.selectedLabel : button.dataset.selectLabel;
    }
    setVariant(card, variant) {
      const button = card.querySelector('[data-extra-choice]');
      button.dataset.variantId = variant?.id || '';
      button.dataset.price = variant?.amount ?? '';
      button.disabled = !variant || this.busy || this.variantPending;
      if (!variant) this.select(card, false);
      if (variant) {
        const price = card.querySelector('[data-extra-price]');
        if (price) price.textContent = variant.price;
      }
    }
    dimension(value) {
      const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
      return match ? match.slice(1).map(number => Number(number.replace(',', '.'))).sort((a,b) => a-b).join('x') : null;
    }
    matchFrames(variant) {
      const dimension = variant?.options?.map(value => this.dimension(value)).find(Boolean);
      this.cards.filter(card => card.hasAttribute('data-frame-match')).forEach(card => {
        const selected = dimension && card.variants.find(item => item.options.some(value => this.dimension(value) === dimension));
        this.select(card, false);
        card.hidden = !selected;
        this.setVariant(card, selected);
      });
    }
    matchShoes(value) {
      const numeric = String(value || '').trim().match(/^(?:EU\s*)?(\d+(?:[.,]\d+)?)\s*(?:EU)?$/i);
      const size = this.dataset.shoeSizePosition !== '' && numeric ? Number(numeric[1].replace(',', '.')) : null;
      this.cards.filter(card => card.hasAttribute('data-shoe-fit')).forEach(card => {
        const selected = size !== null && card.variants.find(variant => {
          const range = variant.title.match(/\((\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)\)/);
          return range && size >= Number(range[1].replace(',', '.')) && size <= Number(range[2].replace(',', '.'));
        });
        this.select(card, false);
        card.hidden = !selected;
        this.setVariant(card, selected);
        const select = card.querySelector('[data-extra-select]');
        if (select) {
          [...select.options].forEach(option => {
            if (option.value) option.disabled = option.hidden = option.value !== String(selected?.id || '');
          });
          select.value = selected?.id || '';
        }
      });
    }
    get items() {
      if (this.hasAttribute('data-separate-addons') || this.variantPending) return [];
      return this.cards.filter(card => !card.hidden).map(card => card.querySelector('[data-extra-choice]'))
        .filter(button => button.getAttribute('aria-pressed') === 'true' && button.dataset.variantId)
        .map(button => ({id:Number(button.dataset.variantId),price:Number(button.dataset.price),
          properties:{_ms_upsell_source:'product_page',_ms_upsell_version:'1'}}));
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelectorAll('[data-extra-select], [data-no-frame]').forEach(control => { control.disabled = busy; });
      this.cards.forEach(card => {
        const button = card.querySelector('[data-extra-choice]');
        button.disabled = busy || !button.dataset.variantId || this.variantPending;
      });
    }
    reset() { this.cards.forEach(card => this.select(card, false)); this.notify(); }
    notify() {
      const frameSelected = this.cards.some(card => card.hasAttribute('data-frame-match') && card.querySelector('[data-extra-choice]').getAttribute('aria-pressed') === 'true');
      this.querySelector('[data-no-frame]')?.setAttribute('aria-pressed', String(!frameSelected));
      const selection = this.querySelector('[data-frame-selection]');
      if (selection) selection.textContent = this.querySelector('[data-frame-label][aria-pressed="true"]')?.dataset.frameLabel || '';
      const empty = this.querySelector('[data-no-matching-frame]');
      if (empty) empty.hidden = this.cards.some(card => !card.hidden);
      document.getElementById(this.dataset.mainForm)?.querySelector('ms-purchase-total')?.update?.();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}


